<script setup>
import UModal from "nvd-u/components/UModal.vue";
import UButton from "nvd-u/components/UButton.vue";
import { useAuthStore } from "../../stores/auth.store";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/stores/app.store";
import { useI18n } from "vue-i18n";

const router = useRouter()
const auth = useAuthStore()
const app = useAppStore()
const { t } = useI18n()

const tableLimitReached = computed(() => {
    return auth.planLimitReached.includes(t('plan_limit.visit_account_dashboard_update_billing'))
})

const projectLimitReached = computed(() => {
    return auth.planLimitReached.includes(t('plan_limit.visit_account_dashboard_delete_schemas'))
})

const linkTitle = computed(() => {
    return t('modals.go_to_dashboard')
})

const getActionLink = computed(() => {
    return '/dashboard'
})

const upgrade = () => {
    app.closeAllModals()
    router.push('/account/billing')
}
</script>

<template>
    <UModal v-model="auth.planLimitReached" title="Plan Limit Reached" dont-close-on-ok dont-close-on-cancel>
        <template #header>
            <h2 class="text-danger text-center" style="margin: 0">{{ $t('modals.plan_limit_reached') }}</h2>
        </template>
        <div class="text-center">
            {{ auth.planLimitReached }}
        </div>
        <template #footer>
            <div class="d-flex flex-grow-1 flex-column align-items-center">
                <UButton @click="upgrade">{{ $t('modals.upgrade_now') }}</UButton>
                <div class="text-with-line">{{ $t('modals.or') }}</div>
                <RouterLink @click="app.closeAllModals" :to="getActionLink">{{ linkTitle }}
                </RouterLink>
            </div>
        </template>
    </UModal>
</template>
